export default __webpack_public_path__ + "static/media/NorthernGrasslands.44fd1c13.jpg";